import React, { useState } from 'react';
import { Calculator, ArrowRight, DollarSign, Euro, Wallet, Building2, Star, Info, ChevronDown, Shield, Percent, ListFilter, X, Search, Users, Sparkles, Crown, ArrowUpRight, Bell, ChevronLeft, ChevronRight, HelpCircle, AlertCircle, ExternalLink } from 'lucide-react';
import FAQ from '../components/FAQ';
import DepositOnboarding from '../components/DepositOnboarding';
import FeaturedDeposits from '../components/FeaturedDeposits';

interface Bank {
  id: string;
  name: string;
  logo: string;
  isSponsored: boolean;
  applicationUrl: string;
  depositTypes: {
    tl: {
      rate: '46.00';
      minAmount: string;
      maxAmount: string;
      minTerm: number;
      maxTerm: number;
    };
    usd: {
      rate: string;
      minAmount: string;
      maxAmount: string;
      minTerm: number;
      maxTerm: number;
    };
    eur: {
      rate: string;
      minAmount: string;
      maxAmount: string;
      minTerm: number;
      maxTerm: number;
    };
  };
}

const banks: Bank[] = [
  {
    id: 'akbank',
    name: 'Akbank',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/7accd65f-06ae-48b1-875e-6d9827590be6.png',
    isSponsored: true,
    applicationUrl: 'https://www.akbank.com/mevduat-yatirim/mevduat/vadeli-mevduat-faiz-hesaplama',
    depositTypes: {
      tl: {
        rate: '44.00',
        minAmount: '50.000',
        maxAmount: '10.000.000',
        minTerm: 32,
        maxTerm: 365
      },
      usd: {
        rate: '5.25',
        minAmount: '1.000',
        maxAmount: '1.000.000',
        minTerm: 32,
        maxTerm: 365
      },
      eur: {
        rate: '4.75',
        minAmount: '1.000',
        maxAmount: '1.000.000',
        minTerm: 32,
        maxTerm: 365
      }
    }
  },
  {
    id: 'qnb',
    name: 'QNB',
    logo: 'https://cdn.hangikredi.com/images/bankdigitalonboarding/d9ae3539-f63d-4295-84e6-08dbe6e2a6d6.png',
    isSponsored: true,
    applicationUrl: 'https://www.qnb.com.tr/vadeli-mevduat-urunleri',
    depositTypes: {
      tl: {
        rate: '50.25',
        minAmount: '100.000',
        maxAmount: '5.000.000',
        minTerm: 32,
        maxTerm: 365
      },
      usd: {
        rate: '5.15',
        minAmount: '1.000',
        maxAmount: '500.000',
        minTerm: 32,
        maxTerm: 365
      },
      eur: {
        rate: '4.65',
        minAmount: '1.000',
        maxAmount: '500.000',
        minTerm: 32,
        maxTerm: 365
      }
    }
  }
];

const faqData = [
  {
    question: 'Mevduat Hesabı Nedir?',
    answer: 'Mevduat hesabı, bankaya para yatırmanız için oluşturulan hesaptır. Tasarruf etme, ödeme yapma gibi amaçlarla kullanıldığı gibi, vadeli mevduat hesabı olması durumunda faiz geliri de edebilirsiniz. Mevduat hesabının bilinen çeşitleri ise şunlardır; vadeli mevduat hesabı, vadesiz mevduat hesabı, kredili mevduat hesabı, Çeyiz hesabı, döviz hesabı, altın hesabı, birikim hesabı.'
  },
  {
    question: 'Mevduat Hesabı Çeşitleri Nelerdir?',
    answer: 'Mevduat hesapları amacına göre tasarruf ve ticari mevduat olarak ikiye ayrılır. Ticari mevduat adı üstüne işletmeler içindir. Tasarruf mevduat ise genellikle 1,3,6 ve 12 ay boyunca yatırılan paranın banka tarafından güvende altına alındığı, müşterinin çekme ya da para ekleme yapmasının yasak olduğu, belirtilen süre dolunca bir faiz gelirinin elde edildiği hesaplardır.'
  },
  {
    question: 'Vadesiz hesap nedir? Nasıl açılır, nasıl kapatma yapılır?',
    answer: 'Vadesiz mevduat hesabı, tasarruf hesaplarından biridir. Ancak bir faiz geliri yoktur. Maaş hesabınız bunun bir örneğidir. Para biriktirebilir veya harcamalarınız için kullanabilirsiniz. İster dijital bankacılık ister mobil bankacılık yoluyla açıp, kapatabilirsiniz. Tüm bunlar dışında yine banka şubesinin yolunu da tutabilirsiniz.'
  },
  {
    question: 'Vadeli Mevduat hesabı nedir ne anlama gelir ? Nasıl açılır, nasıl kapatılır?',
    answer: 'Vadeli mevduat, faiz geliri elde edebildiğiniz hesap türüdür. Genellikle 1,3, 6 ve 12 aylık periyotları olan bu hesap türüne bir miktar para yatırırsınız ve bu süreler dolunca faiz geliri alırsınız. Dijital bankacılık ya da şube aracılığıyla siz de bir vadeli mevduat hesabı açabilirsiniz.'
  },
  {
    question: 'Para çekersem ya da para yatırırsam vade bozulur mu?',
    answer: 'Evet bozulur. Seçilen periyotlar içinde herhangi bir şekilde para çekememeniz veya hesaba para ekleyememeniz. Bu durumda sadece ana parayı alırsınız.'
  },
  {
    question: 'Vadeli Mevduat hesabı net faiz geliri hesaplama nasıl yapılır?',
    answer: 'Tüm bankaların kullandığı formül aynıdır. Vadeli mevduat hesabına yatırdığınız ve vade sonunda kazanacağız faiz geliri anapara, faiz oranı ve vade süresi dikkate alınarak hesaplanır. Faiz getirisi formülü; Anapara x Faiz Oranı x Vade ya da gün x 36500 olarak hesaplanır.'
  },
  {
    question: 'Vadeli Hesap Ne Kadar Kazandırır?',
    answer: 'Vadeli mevduat hesabı, anaparanız üzerinden hesaplanır. Bankalar sizin yatırdığınız parayı, başka müşterilere kredi vermek için kullanır. Bu süre zarfında işletilen para vade sonunda ; Anapara x Faiz Oranı x Vade ya da gün x 36500 formülüyle hesaplanır. Anaparanız ne kadar fazlaysa o kadar faiz geliri elde edersiniz.'
  },
  {
    question: 'Vadeli Mevduat Hesabı Stopaj Oranları Ne Kadar?',
    answer: 'Günümüz itibariyle stopaj oranları, 6 aya kadar vadeli hesaplarda yüzde 5, 1 yıla kadar vadeli hesaplarda yüzde 3 ve 1 yıldan uzun vadeli hesaplarda 0\'dır.'
  },
  {
    question: 'Banka Faiz Oranlarını Güncellediğinde Hesabımdaki Paranın Faiz Oranı da Değişir Mi?',
    answer: 'Hayır değişmez. Nasıl ki vade boyunca paranıza dokunamıyorsanız, faiz oranınız da vade başındaki gibi aynı kalır. Ayrıca bankalar faiz oranlarını zaman zaman size özel olarak belirler. Bu yüzden de vade bitene kadar faiz oranları güncellenmez.'
  }
];

type DepositType = 'tl' | 'usd' | 'eur';

const Mevduat = () => {
  const [selectedType, setSelectedType] = useState<DepositType>('tl');
  const [amount, setAmount] = useState('50000');
  const [term, setTerm] = useState('32');
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);
  const [isOnboardingOpen, setIsOnboardingOpen] = useState(false);

  const handleCalculate = () => {
    setIsOnboardingOpen(true);
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-gradient-to-b from-[#F7BA45]/20 to-slate-50 py-8 md:py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-slate-800 mb-4 md:mb-6">
              Mevduat Hesaplama
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-slate-600 mb-8 md:mb-12">
              Size en uygun mevduat hesabını bulun, faiz oranlarını karşılaştırın
            </p>

            {/* Calculator Section */}
            <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-xl border border-slate-200">
              {/* Deposit Type Selection */}
              <div className="grid grid-cols-3 gap-2 mb-6 md:mb-8">
                <button
                  onClick={() => setSelectedType('tl')}
                  className={`flex flex-col items-center gap-2 p-3 md:p-6 rounded-xl transition-all ${
                    selectedType === 'tl'
                      ? 'bg-[#F7BA45] text-slate-900'
                      : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
                >
                  <Wallet size={24} className="hidden sm:block" />
                  <Wallet size={20} className="sm:hidden" />
                  <span className="font-medium text-sm sm:text-base">TL Mevduat</span>
                </button>
                <button
                  onClick={() => setSelectedType('usd')}
                  className={`flex flex-col items-center gap-2 p-3 md:p-6 rounded-xl transition-all ${
                    selectedType === 'usd'
                      ? 'bg-[#F7BA45] text-slate-900'
                      : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
                >
                  <DollarSign size={24} className="hidden sm:block" />
                  <DollarSign size={20} className="sm:hidden" />
                  <span className="font-medium text-sm sm:text-base">Dolar Mevduat</span>
                </button>
                <button
                  onClick={() => setSelectedType('eur')}
                  className={`flex flex-col items-center gap-2 p-3 md:p-6 rounded-xl transition-all ${
                    selectedType === 'eur'
                      ? 'bg-[#F7BA45] text-slate-900'
                      : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
                >
                  <Euro size={24} className="hidden sm:block" />
                  <Euro size={20} className="sm:hidden" />
                  <span className="font-medium text-sm sm:text-base">Euro Mevduat</span>
                </button>
              </div>

              {/* Amount and Term Inputs */}
              <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-6 md:mb-8">
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-slate-700">
                    Tutar
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-3 flex items-center text-slate-500">
                      {selectedType === 'tl' ? '₺' : selectedType === 'usd' ? '$' : '€'}
                    </span>
                    <input
                      type="text"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="block w-full pl-8 pr-12 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45] transition-colors text-sm md:text-base"
                    />
                    <span className="absolute inset-y-0 right-3 flex items-center text-slate-500 text-sm">
                      {selectedType.toUpperCase()}
                    </span>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-slate-700">
                    Vade
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={term}
                      onChange={(e) => setTerm(e.target.value)}
                      className="block w-full px-3 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45] transition-colors text-sm md:text-base"
                    />
                    <span className="absolute inset-y-0 right-3 flex items-center text-slate-500 text-sm">
                      Gün
                    </span>
                  </div>
                </div>
              </div>

              {/* Calculate Button */}
              <button
                onClick={handleCalculate}
                className="w-full bg-[#F7BA45] hover:bg-[#e5ac3d] text-slate-900 font-medium py-3 md:py-4 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 group shadow-md hover:shadow-lg text-sm md:text-base"
              >
                MEVDUAT HESAPLA
                <ArrowRight className="transition-transform group-hover:translate-x-1" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bank Results */}
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="max-w-7xl mx-auto">
          <FeaturedDeposits />

          <div className="space-y-4">
            {banks.map((bank) => (
            <div
              key={bank.id}
              className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:border-[#F7BA45]/50 transition-all duration-300 hover:shadow-lg"
            >
              <div className="p-4 md:p-6">
                {/* Bank Header */}
                <div className="flex items-center justify-between mb-4 md:mb-6">
                  <div className="flex items-center gap-3 md:gap-4">
                    <img 
                      src={bank.logo} 
                      alt={bank.name} 
                      className="h-8 md:h-12 object-contain"
                    />
                    <div>
                      <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="text-lg md:text-xl font-semibold text-slate-800">{bank.name}</h3>
                        {bank.isSponsored && (
                          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#F7BA45] text-white text-xs font-medium">
                            <Star size={12} />
                            Sponsor
                          </span>
                        )}
                      </div>
                      <p className="text-xs md:text-sm text-slate-600">Yeni Müşterilere Özel</p>
                    </div>
                  </div>
                </div>

                {/* Bank Details */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-4 md:mb-6">
                  <div className="bg-slate-50 rounded-xl p-3 md:p-4">
                    <div className="text-xs md:text-sm text-slate-500 mb-1">Tutar</div>
                    <div className="font-semibold text-slate-800 text-sm md:text-base">
                      {bank.id === 'akbank' ? '50.000 TL' : bank.id === 'qnb' ? '100.000 TL' : `${bank.depositTypes[selectedType].minAmount} ${selectedType.toUpperCase()}`}
                    </div>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3 md:p-4">
                    <div className="text-xs md:text-sm text-slate-500 mb-1">Vade</div>
                    <div className="font-semibold text-slate-800 text-sm md:text-base">
                      32 Gün
                    </div>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3 md:p-4">
                    <div className="text-xs md:text-sm text-slate-500 mb-1">Faiz Oranı</div>
                    <div className="font-semibold text-slate-800 text-sm md:text-base">
                      {bank.id === 'akbank' ? '%44' : bank.id === 'qnb' ? '%44' : `%${bank.depositTypes[selectedType].rate}`}
                    </div>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3 md:p-4">
                    <div className="text-xs md:text-sm text-slate-500 mb-1">Vade Sonu Tutar</div>
                    <div className="font-semibold text-slate-800 text-sm md:text-base">
                      {bank.id === 'akbank' ? '51.690,65 TL' : bank.id === 'qnb' ? '103.381,30 TL' : '561.060 TL'}
                    </div>
                  </div>
                </div>

                {/* Bank Actions */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                  <div className="flex items-center gap-2 text-xs md:text-sm text-slate-600">
                    <Info size={16} className="text-[#F7BA45]" />
                    <span>Başvuru için {bank.name}'a yönlendirilirsiniz</span>
                  </div>
                  <div className="flex items-center gap-3 w-full sm:w-auto">
                    <a href="#" className="text-xs md:text-sm text-[#F7BA45] hover:underline whitespace-nowrap">
                      Koşullar
                      <ExternalLink size={12} className="inline-block ml-1" />
                    </a>
                    <a
                      href={bank.applicationUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 sm:flex-none bg-[#F7BA45] hover:bg-[#e5ac3d] text-slate-900 px-4 md:px-6 py-2.5 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 shadow-md hover:shadow-lg text-sm md:text-base cursor-pointer"
                    >
                      BANKAYA DEVAM ET
                      <ArrowRight size={16} className="hidden sm:block" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-slate-800 mb-4">
                Mevduat Hakkında Sıkça Sorulan Sorular
              </h2>
              <p className="text-slate-600">
                Mevduat hesapları hakkında merak ettiğiniz tüm sorular ve cevapları
              </p>
            </div>

            <div className="space-y-4">
              {faqData.map((faq, index) => (
                <div
                  key={index}
                  className={`border rounded-xl transition-all duration-300 ${
                    expandedFaq === index
                      ? 'border-[#F7BA45] bg-[#F7BA45]/5'
                      : 'border-slate-200 hover:border-slate-300'
                  }`}
                >
                  <button
                    className="w-full px-6 py-4 text-left flex items-center justify-between"
                    onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                  >
                    <div className="flex items-center gap-3">
                      {expandedFaq === index ? (
                        <AlertCircle size={20} className="text-[#F7BA45]" />
                      ) : (
                        <HelpCircle size={20} className="text-slate-400" />
                      )}
                      <span className="font-medium text-slate-800">{faq.question}</span>
                    </div>
                    <ChevronDown
                      size={20}
                      className={`text-slate-400 transition-transform duration-300 ${
                        expandedFaq === index ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      expandedFaq === index ? 'max-h-[500px]' : 'max-h-0'
                    }`}
                  >
                    <div className="px-6 pb-4 text-slate-600">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Deposit Onboarding Modal */}
      <DepositOnboarding
        isOpen={isOnboardingOpen}
        onClose={() => setIsOnboardingOpen(false)}
        depositAmount={amount}
        depositTerm={term}
        depositType={selectedType}
      />
    </div>
  );
};

export default Mevduat;